import { render, staticRenderFns } from "./piweb-menu-item.vue?vue&type=template&id=4aa6a8a6&scoped=true&"
import script from "./piweb-menu-item.vue?vue&type=script&lang=js&"
export * from "./piweb-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./piweb-menu-item.vue?vue&type=style&index=0&id=4aa6a8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa6a8a6",
  null
  
)

export default component.exports